export type HwcgNoticeFollowUpStatus = 'sent' | 'waiting' | 'not_released';

export type HwcgNoticeStepRecipientRow = {
  userGuid: string;
  name: string;
  deliveryState?: string | null;
  sentAt?: string | null;
  step1Response: string | null;
  step2Status: HwcgNoticeFollowUpStatus | null;
  step2Response: string | null;
};

export type HwcgNoticeStepReportDto = {
  notificationId: string;
  step1Tallies: Record<string, number>;
  step2Tallies: Record<string, number>;
  recipients: HwcgNoticeStepRecipientRow[];
};

/** Recompute option counts from recipient rows (keeps UI chips in sync with the table). */
export function tallyHwcgNoticeOptionCounts(
  recipients: HwcgNoticeStepRecipientRow[],
  field: 'step1Response' | 'step2Response'
): Record<string, number> {
  const tallies: Record<string, number> = {};
  for (const row of recipients) {
    const value = row[field]?.trim() || 'Awaiting';
    tallies[value] = (tallies[value] ?? 0) + 1;
  }
  return tallies;
}

export function followUpStatusLabel(
  status: HwcgNoticeFollowUpStatus | null
): string {
  if (status === 'sent') return 'Sent';
  if (status === 'waiting') return 'Awaiting step 1';
  if (status === 'not_released') return 'Not released';
  return '—';
}
